/**
 * Question sets pour formulaires de qualification de leads
 * Mode "ultra" = questions plus directes et qualifiantes (budget, timeline, etc.)
 */

export const leadQuestionSets = {
  /**
   * NETTOYAGE - Mode standard (existant)
   */
  nettoyage_standard: [
    {
      id: 'type_nettoyage',
      label: 'Type de nettoyage',
      type: 'select',
      options: ['Canapé', 'Terrasse', 'Vitres', 'Fin de chantier', 'Après bail', 'Autre'],
      placeholder: 'Sélectionner',
      required: false
    },
    {
      id: 'surface',
      label: 'Surface approximative (m²)',
      type: 'input',
      placeholder: 'Ex: 50',
      required: false
    }
  ],

  /**
   * NETTOYAGE - Mode ultra (qualification)
   */
  nettoyage_ultra: [
    {
      id: 'type_nettoyage',
      label: 'Type de nettoyage *',
      type: 'select',
      options: ['Canapé', 'Terrasse', 'Vitres', 'Fin de chantier', 'Après bail', 'Autre'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'surface',
      label: 'Surface approximative (m²) *',
      type: 'input',
      placeholder: 'Ex: 50',
      required: true
    },
    {
      id: 'budget',
      label: 'Budget estimé *',
      type: 'select',
      options: ['< 500 CHF', '500-1000 CHF', '1000-2000 CHF', '> 2000 CHF'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'delai',
      label: 'Délai souhaité *',
      type: 'select',
      options: ['Urgent (< 1 semaine)', '1-2 semaines', '2-4 semaines', 'Flexible (> 1 mois)'],
      placeholder: 'Sélectionner',
      required: true
    }
  ],

  /**
   * CONCIERGERIE AIRBNB - Mode standard
   */
  conciergerie_standard: [
    {
      id: 'type_bien',
      label: 'Type de bien',
      type: 'select',
      options: ['Studio', 'Appartement', 'Chalet', 'Villa', 'Autre'],
      placeholder: 'Sélectionner',
      required: false
    },
    {
      id: 'chambres',
      label: 'Nombre de chambres',
      type: 'input',
      placeholder: 'Ex: 2',
      required: false
    }
  ],

  /**
   * CONCIERGERIE AIRBNB - Mode ultra
   */
  conciergerie_ultra: [
    {
      id: 'type_bien',
      label: 'Type de bien *',
      type: 'select',
      options: ['Studio', 'Appartement', 'Chalet', 'Villa', 'Autre'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'chambres',
      label: 'Nombre de chambres *',
      type: 'input',
      placeholder: 'Ex: 2',
      required: true
    },
    {
      id: 'deja_loue',
      label: 'Déjà loué en courte durée ? *',
      type: 'select',
      options: ['Oui, actuellement', 'Oui, par le passé', 'Non, jamais'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'objectif_revenu',
      label: 'Objectif revenu mensuel *',
      type: 'select',
      options: ['< 2000 CHF', '2000-5000 CHF', '5000-10000 CHF', '> 10000 CHF'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'disponibilite',
      label: 'Disponibilité du bien *',
      type: 'select',
      options: ['Immédiat', 'Dans 1 mois', 'Dans 2-3 mois', 'Plus tard'],
      placeholder: 'Sélectionner',
      required: true
    }
  ],

  /**
   * RÉNOVATION - Mode standard
   */
  renovation_standard: [
    {
      id: 'type_projet',
      label: 'Type de projet',
      type: 'select',
      options: ['Cuisine', 'Salle de bain', 'Peinture', 'Parquet', 'Rénovation complète', 'Autre'],
      placeholder: 'Sélectionner',
      required: false
    },
    {
      id: 'surface',
      label: 'Surface concernée (m²)',
      type: 'input',
      placeholder: 'Ex: 20',
      required: false
    }
  ],

  /**
   * RÉNOVATION - Mode ultra
   */
  renovation_ultra: [
    {
      id: 'type_projet',
      label: 'Type de projet *',
      type: 'select',
      options: ['Cuisine', 'Salle de bain', 'Peinture', 'Parquet', 'Rénovation complète', 'Autre'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'surface',
      label: 'Surface concernée (m²) *',
      type: 'input',
      placeholder: 'Ex: 20',
      required: true
    },
    {
      id: 'budget',
      label: 'Budget estimé *',
      type: 'select',
      options: ['< 10000 CHF', '10000-30000 CHF', '30000-70000 CHF', '> 70000 CHF'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'delai',
      label: 'Délai souhaité *',
      type: 'select',
      options: ['Urgent (< 1 mois)', '1-3 mois', '3-6 mois', 'Flexible (> 6 mois)'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'proprietaire',
      label: 'Vous êtes *',
      type: 'select',
      options: ['Propriétaire', 'Locataire (avec accord)', 'Gérant/Agence'],
      placeholder: 'Sélectionner',
      required: true
    }
  ],

  /**
   * MARKETING - Mode standard
   */
  marketing_standard: [
    {
      id: 'service_interesse',
      label: 'Service recherché',
      type: 'select',
      options: ['Site web', 'SEO', 'Google Ads', 'Meta Ads', 'Automatisation IA', 'Pack complet'],
      placeholder: 'Sélectionner',
      required: false
    },
    {
      id: 'secteur_activite',
      label: 'Secteur d\'activité',
      type: 'input',
      placeholder: 'Ex: Immobilier, Hôtellerie',
      required: false
    }
  ],

  /**
   * MARKETING - Mode ultra
   */
  marketing_ultra: [
    {
      id: 'service_interesse',
      label: 'Service recherché *',
      type: 'select',
      options: ['Site web', 'SEO', 'Google Ads', 'Meta Ads', 'Automatisation IA', 'Pack complet'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'secteur_activite',
      label: 'Secteur d\'activité *',
      type: 'input',
      placeholder: 'Ex: Immobilier, Hôtellerie',
      required: true
    },
    {
      id: 'objectif_principal',
      label: 'Objectif principal *',
      type: 'select',
      options: ['Générer plus de leads', 'Augmenter visibilité', 'Améliorer conversions', 'Autre'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'budget_mensuel',
      label: 'Budget mensuel *',
      type: 'select',
      options: ['< 1000 CHF', '1000-3000 CHF', '3000-7000 CHF', '> 7000 CHF'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'delai_lancement',
      label: 'Délai de lancement *',
      type: 'select',
      options: ['Urgent (< 2 semaines)', '1 mois', '2-3 mois', 'Flexible'],
      placeholder: 'Sélectionner',
      required: true
    }
  ],

  /**
   * IMMOBILIER - Mode standard
   */
  immo_standard: [
    {
      id: 'type_projet',
      label: 'Votre projet',
      type: 'select',
      options: ['Vendre mon bien', 'Acheter un bien', 'Estimation', 'Conseil'],
      placeholder: 'Sélectionner',
      required: false
    },
    {
      id: 'type_bien',
      label: 'Type de bien',
      type: 'select',
      options: ['Appartement', 'Maison', 'Chalet', 'Terrain', 'Commercial', 'Autre'],
      placeholder: 'Sélectionner',
      required: false
    }
  ],

  /**
   * IMMOBILIER - Mode ultra
   */
  immo_ultra: [
    {
      id: 'type_projet',
      label: 'Votre projet *',
      type: 'select',
      options: ['Vendre mon bien', 'Acheter un bien', 'Estimation', 'Conseil'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'type_bien',
      label: 'Type de bien *',
      type: 'select',
      options: ['Appartement', 'Maison', 'Chalet', 'Terrain', 'Commercial', 'Autre'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'valeur_estimee',
      label: 'Valeur estimée *',
      type: 'select',
      options: ['< 500K CHF', '500K-1M CHF', '1M-2M CHF', '> 2M CHF'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'delai_projet',
      label: 'Délai du projet *',
      type: 'select',
      options: ['Urgent (< 1 mois)', '1-3 mois', '3-6 mois', 'Flexible (> 6 mois)'],
      placeholder: 'Sélectionner',
      required: true
    },
    {
      id: 'deja_mandataire',
      label: 'Déjà un mandataire ? *',
      type: 'select',
      options: ['Non', 'Oui, mais pas satisfait', 'Oui, mandat exclusif', 'Juste une estimation'],
      placeholder: 'Sélectionner',
      required: true
    }
  ]
};

/**
 * Helper function to get question set based on pole and variant
 * @param {string} pole - Service pole (nettoyage, conciergerie, renovation, marketing, immo)
 * @param {string} variant - Form variant ('standard' or 'ultra')
 * @returns {Array} Question set
 */
export const getQuestionSet = (pole, variant = 'standard') => {
  const key = `${pole}_${variant}`;
  return leadQuestionSets[key] || leadQuestionSets[`${pole}_standard`] || [];
};
